import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import cities from "../assets/cities.json"
import provinces from "../assets/provinces.json"
import { Select } from "components"
import classes from "./CdsamCityAndStateSelect.module.scss"

const AbCityAndStateSelect = (props) => {
  const {
    form,
    formErrors,
    setForm,
    disabled = false
  } = props

  const [t] = useTranslation()

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  return (
    <Fragment>
      <Select
        isDisabled={disabled}
        label={t("استان")}
        maxMenuHeight={150}
        noOptionsMessage={() => t("هیچ_استانی_یافت_نشد")}
        options={provinces}
        error={formErrors.state}
        className={classes["container"]}
        onChange={(select) => handleChange(select.value, "state")}
        value={form.state
          ? { label: form.state, value: form.state }
          : null
        }
      />
      <Select
        label={t("شهر")}
        isDisabled={disabled}
        maxMenuHeight={150}
        noOptionsMessage={() => t("هیچ_شهری_یافت_نشد")}
        options={cities[form.state] || []}
        error={formErrors.city}
        className={classes["container"]}
        onChange={(select) => handleChange(select.value, "city")}
        value={form.city
          ? { label: form.city, value: form.city }
          : null
        }
      />
    </Fragment>
  )
}

export default AbCityAndStateSelect
